import React from 'react';

const Ex2_Training = () => {
    return (
        <div>Ex2_Training Component</div>
    );
}

export default Ex2_Training;
